<template>
  <div class="cover-selector">
    <svg
      style="position: absolute; z-index: -1"
      xmlns="http://www.w3.org/2000/svg"
      width="0"
      height="0"
    >
      <filter :id="'filter' + filterId" primitiveUnits="objectBoundingBox">
        <template v-if="watermark.img && watermark.img.type">
          <feFlood
            :flood-color="watermark.img.type"
            x="0"
            y="0"
            width="100%"
            height="100%"
          />
          <feComposite in2="SourceGraphic" operator="in" />
        </template>
      </filter>
    </svg>
    <div class="cover-selector__inner cover-selector__layer" :style="{ width }">
      <cover-player
        class="cover-selector__layer"
        :screenHeight="screenHeight"
        :screenRatio="screenRatio"
        :coverParams="coverParams"
        :fontNameLookup="fontNameLookup"
        :hasStamp="hasStamp"
        :stampRule="watermark"
        :filterId="visible && filterId"
      />
      <div class="cover-selector__layer" v-if="!readonly">
        <!-- <div class="cover-selector__layer" @click="handleEffectSelect(-1)" /> -->
        <div
          class="effect-cover__hover effect-cover__hover--hidden"
          v-for="(c, i) in coverStyles"
          :key="i"
          :style="c"
          @click="handleEffectSelect(i)"
          @mousedown="handleEffectDrag($event, i)"
        />
        <cover-selection
          :selectedEffect="selectedEffect"
          :nextEffects="nextEffects"
          :dragging.sync="dragging"
          @selectCover="handleCoverSelect"
          :scale="scale"
          :fontStates="fontStates"
        />
      </div>
    </div>
    <div class="cover-editor" v-if="selectedEffect">
      <h4 class="cover-editor__title">
        {{ selectedEffect.type ? "封面贴纸属性" : "封面文本属性" }}
      </h4>
      <button type="button" class="cover-editor__close" @click="close">
        &times;
      </button>
      <div class="cover-editor__content">
        <template v-if="!selectedEffect.type">
          <div class="cover-editor-row">
            <span>字体</span>
            <el-select v-model="selectedEffect.fontFamily" size="mini">
              <el-option
                v-for="(item, i) in fontList"
                :key="item.font_name"
                :value="item.font_name"
                :style="{ backgroundPosition: `10px ${-i * 32}px` }"
                :label="item.font_name"
                class="cover-editor__display"
              />
            </el-select>
          </div>
          <div class="cover-editor-row">
            <span>字号</span>
            <el-input-number
              v-model="selectedEffect.fontSize"
              size="mini"
              controls-position="right"
              :disabled="selectedEffect.autoFontSize"
              :min="1"
            />
            <span>自动调整</span>
            <el-switch v-model="selectedEffect.autoFontSize" />
          </div>
          <div class="cover-editor-row">
            <span>行高</span>
            <el-input-number
              v-model="selectedEffect.lineHeight"
              size="mini"
              controls-position="right"
              :step="0.05"
              :min="0"
            />
          </div>
          <div class="cover-editor-row">
            <span>字间距</span>
            <el-input-number
              v-model="selectedEffect.letterSpacing"
              size="mini"
              controls-position="right"
              :step="1"
              :min="0"
              class="cover-editor-row__percentage"
            />
          </div>
          <div class="cover-editor-row">
            <span>背景颜色</span>
            <el-color-picker
              v-model="selectedEffect.background"
              size="mini"
              show-alpha
            />
          </div>
          <div class="cover-editor-row">
            <span>文本填充</span>
            <color-gradient-editor
              v-model="selectedEffect.color"
              :gradient.sync="selectedEffect.gradient"
              show-alpha
              hide-picker
            />
          </div>
          <div class="cover-editor-row">
            <span>描边宽度</span>
            <el-input-number
              v-model="selectedEffect.strokeWidth"
              size="mini"
              controls-position="right"
              :step="1"
              :min="0"
            />
            <span>描边</span>
            <color-gradient-editor
              v-model="selectedEffect.stroke"
              :gradient.sync="selectedEffect.strokeGradient"
              show-alpha
              hide-picker
            />
          </div>
          <div class="cover-editor-row">
            <span>段落对齐</span>
            <el-radio-group v-model="selectedEffect.align" size="mini">
              <el-radio-button label="left">
                <i class="iconfont icon-AlignLeft" />
              </el-radio-button>
              <el-radio-button label="center">
                <i class="iconfont icon-AlignCenter" />
              </el-radio-button>
              <el-radio-button label="right">
                <i class="iconfont icon-AlighRight" />
              </el-radio-button>
            </el-radio-group>
          </div>
        </template>
        <position-editor
          :effect="selectedEffect"
          :noContent="true"
          :containerSize="canvasSize"
        />
        <div class="cover-editor-row">
          <span>不透明度</span>
          <el-slider
            v-model="selectedEffect.opacity"
            size="mini"
            show-input
            :step="1"
            :min="0"
            :max="100"
            :show-input-controls="false"
            input-size="mini"
          />
        </div>
        <div class="cover-editor-row">
          <span>阴影</span>
          <el-switch v-model="selectedEffect.useShadow" />
        </div>
        <template v-if="selectedEffect.useShadow && selectedEffect.shadow">
          <div class="cover-editor-row">
            <span>颜色</span>
            <el-color-picker
              v-model="selectedEffect.shadow.color"
              size="mini"
              show-alpha
            />
            <span>模糊</span>
            <el-input-number
              v-model="selectedEffect.shadow.blur"
              size="mini"
              controls-position="right"
              :step="1"
              :min="0"
            />
          </div>
          <div class="cover-editor-row">
            <span>x</span>
            <el-input-number
              v-model="selectedEffect.shadow.x"
              size="mini"
              controls-position="right"
              :min="-100"
              :max="100"
            />
            <span>y</span>
            <el-input-number
              v-model="selectedEffect.shadow.y"
              size="mini"
              controls-position="right"
              :min="-100"
              :max="100"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { rotateBy } from '../../utils';
import CoverPlayer from '../coverEditor/CoverPlayer';
import CoverSelection from '../coverEditor/CoverSelection';
import ColorGradientEditor from '../base/ColorGradientEditor';
import PositionEditor from './PositionEditor';
import '../coverEditor/CoverSelector.vue?vue&type=style&index=0&lang=css';
import '../coverEditor/CoverEditor.vue?vue&type=style&index=0&lang=css';
import '../effectCover/EffectCover.vue?vue&type=style&index=0&lang=css';

export default {
  props: ['visible', 'readonly', 'activeIndex', 'screenHeight', 'screenRatio', 'coverParams', 'fontList', 'width', 'fontStates', 'hasStamp', 'watermark'],
  components: { ColorGradientEditor, CoverPlayer, CoverSelection, PositionEditor },
  data() {
    return {
      dragging: null,
      scale: 1,
      filterId: ('' + Math.random()).slice(2)
    };
  },
  computed: {
    canvasSize() {
      const height = Math.round(this.screenHeight);
      const width = Math.round(this.screenRatio * this.screenHeight);

      return { width, height };
    },
    coverStyles() {
      return this.coverParams.map(c => {
        const ret = {};
        ['left', 'width'].forEach(k => {
          ret[k] = c[k] / this.canvasSize.width * 100 + '%';
        });
        ['top', 'height'].forEach(k => {
          ret[k] = c[k] / this.canvasSize.height * 100 + '%';
        });

        ret.transform = `rotate(${c.rotate || 0}deg)`;

        return ret;
      });
    },
    selectedEffectIndex: {
      get() {
        return this.activeIndex;
      },
      set(value) {
        this.$emit('update:activeIndex', value);
      }
    },
    selectedEffect() {
      return this.coverParams[this.selectedEffectIndex] || null;
    },
    nextEffects() {
      return this.coverParams.slice(this.selectedEffectIndex + 1);
    },
    fontNameLookup() {
      const ret = {};
      this.fontList.forEach(t => {
        ret[t.font_name] = t.font_alias;
      })
      return ret;
    },
    screenMarker() {
      return this.visible && this.screenRatio;
    }
  },
  methods: {
    /**
     * TODO: pretend that it were done
     * @param{MouseEvent}e
     */
    handleMouseMove(e) {
      if (this.dragging) {
        let actualDir = this.dragging.dir || '';
        const selectedEffect = this.selectedEffect;

        let deltaX;
        let deltaY;
        if (this.dragging.rotate) {
          console.log('rotating');
          const [centerX, centerY] = this.dragging.rotate;

          deltaX = e.clientX - centerX;
          deltaY = e.clientY - centerY;

          let rotation;
          if (deltaX) {
            rotation = (Math.atan(deltaY / deltaX) * 180 / Math.PI + (deltaX > 0 ? 180 : 0)) - 90;
          } else {
            rotation = deltaY > 0 ? 180 : 0;
          }

          const rotate = rotation;
          selectedEffect.rotate = e.shiftKey ? Math.round(rotate / 45) * 45 : Math.round(rotate);
          return;
        }

        deltaX = (e.clientX - this.dragging.clientX) / this.scale;
        deltaY = (e.clientY - this.dragging.clientY) / this.scale;

        // TODO: get rotated deltas when resizing, but only use the dragged one
        const efRotate = this.draggingEffect.rotate;
        if (actualDir) {
          if (efRotate) {
            const unrotatedDelta = rotateBy({ x: deltaX, y: deltaY }, { x: 0, y: 0 }, -efRotate);
            deltaX = unrotatedDelta.x;
            deltaY = unrotatedDelta.y;
          }
        }

        if (actualDir && e.shiftKey) {
          const prevRatio = (
            actualDir === 'tr' || actualDir === 'bl' ? -1 : 1
          ) * this.draggingEffect.height / this.draggingEffect.width;
          deltaY = deltaX * prevRatio;
        } else if (e.shiftKey) {
          if (Math.abs(deltaX / deltaY) >= 1) {
            deltaY = 0;
          } else {
            deltaX = 0;
          }
        }

        let nextEfc;

        switch (actualDir) {
          case 'tr':
            nextEfc = {
              width: Math.max(this.draggingEffect.width + deltaX, 1),
              top: this.draggingEffect.top + deltaY,
              height: Math.max(this.draggingEffect.height - deltaY, 1)
            };
            break;
          case 'br':
            nextEfc = {
              width: Math.max(this.draggingEffect.width + deltaX, 1),
              height: Math.max(this.draggingEffect.height + deltaY, 1)
            };
            break;
          case 'bl':
            nextEfc = {
              width: Math.max(this.draggingEffect.width - deltaX, 1),
              left: this.draggingEffect.left + deltaX,
              height: Math.max(this.draggingEffect.height + deltaY, 1)
            };
            break;
          case 'tl':
            nextEfc = {
              width: Math.max(this.draggingEffect.width - deltaX, 1),
              top: this.draggingEffect.top + deltaY,
              left: this.draggingEffect.left + deltaX,
              height: Math.max(this.draggingEffect.height - deltaY, 1)
            };
            break;
          default:
            nextEfc = {
              left: this.draggingEffect.left + deltaX,
              top: this.draggingEffect.top + deltaY
            };
        }

        // TODO: alignment of vertices
        if (efRotate && actualDir) {
          const center = { x: this.draggingEffect.width / 2, y: this.draggingEffect.height / 2 };
          const nextCenter = { x: nextEfc.width / 2, y: nextEfc.height / 2 };
          let anchor, nextAnchor;

          switch (actualDir) {
            case 'tr':
              // align bottom left
              {
                anchor = rotateBy(
                  { x: 0, y: this.draggingEffect.height },
                  center,
                  efRotate
                );

                nextAnchor = rotateBy(
                  { x: 0, y: nextEfc.height },
                  nextCenter,
                  efRotate
                );
              }
              break;
            case 'br':
              // align top left
              {
                anchor = rotateBy(
                  { x: 0, y: 0 },
                  center,
                  efRotate
                );

                nextAnchor = rotateBy(
                  { x: 0, y: 0 },
                  nextCenter,
                  efRotate
                );
              }
              break;
            case 'bl':
              // align top right
              {
                anchor = rotateBy(
                  { x: this.draggingEffect.width, y: 0 },
                  center,
                  efRotate
                );

                nextAnchor = rotateBy(
                  { x: nextEfc.width, y: 0 },
                  nextCenter,
                  efRotate
                );
              }
              break;
            case 'tl':
              // align bottom right
              {
                anchor = rotateBy(
                  { x: this.draggingEffect.width, y: this.draggingEffect.height },
                  center,
                  efRotate
                );

                nextAnchor = rotateBy(
                  { x: nextEfc.width, y: nextEfc.height },
                  nextCenter,
                  efRotate
                );
              }
              break;
          }
          if (anchor) {
            nextEfc.top = this.draggingEffect.top + anchor.y - nextAnchor.y;
            nextEfc.left = this.draggingEffect.left + anchor.x - nextAnchor.x;
          }
        }

        if (deltaX || deltaY) {
          this.dragged = true;
        }

        if (nextEfc && this.dragged) {
          Object.keys(nextEfc).forEach(k => {
            this.selectedEffect[k] = nextEfc[k];
          });
        }
      }
    },
    handleMouseUp() {
      if (this.dragging) {
        this.dragging = false;
      }
    },
    handleEffectSelect(i) {
      this.selectedEffectIndex = i;
    },
    handleEffectDrag(e, i) {
      this.selectedEffectIndex = i;
      this.dragging = {
        clientX: e.clientX,
        clientY: e.clientY,
        effect: this.coverParams[i],
        ctrlKey: e.ctrlKey
      };
    },
    handleCoverSelect({ event, index }) {
      console.log(index);
      const nextIndex = this.selectedEffectIndex + 1 + index;

      const ef = this.coverParams[nextIndex];
      if (ef) {
        this.handleEffectDrag(event, nextIndex);
      }
    },
    close() {
      this.handleEffectSelect(-1);
    }
  },

  watch: {
    dragging(val, prev) {
      if (val && !prev) {
        document.body.classList.add('unselectable');
        this.dragged = false;

        const effect = this.dragging.effect;
        const { top, left, width, height, rotate } = effect;
        this.draggingEffect = { top, left, width, height, rotate };
      } else if (prev && !val) {
        setTimeout(() => {
          document.body.classList.remove('unselectable');
        }, 0);
      }
    },
    visible(val) {
      if (!val) {
        this.selectedEffectIndex = -1;
      }
    },
    screenMarker(val) {
      if (val) {
        this.$nextTick(() => {
          this.scale = this.$el.getBoundingClientRect().height / this.screenHeight;
        });
      }
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);

    this.scale = this.$el.getBoundingClientRect().height / this.screenHeight;
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }
}
</script>
<style>
.cover-editor-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}

.cover-editor-row .el-input-number {
  width: 75px;
}

.cover-editor-row .el-input-number.is-controls-right .el-input__inner {
  padding-right: 35px;
  padding-left: 10px;
}

.cover-editor-row .el-radio-button .iconfont {
  font-size: 100%;
}

.cover-editor-row .el-slider {
  flex-grow: 1;
  margin-left: 24px;
}

.cover-editor-row .el-slider__input {
  width: 60px;
}

.cover-editor-row .el-slider__runway.show-input {
  margin-right: 84px;
}

.cover-editor-row .el-color-picker__trigger {
  width: 50px;
  height: 27px;
}

.cover-editor-row .el-color-picker__color {
  border: 0;
}

.cover-editor-row .el-color-picker__icon {
  display: none;
}

.cover-editor-row .color-gradient-editor {
  margin: 0;
}

.cover-editor-row__percentage:after {
  content: "%";
  position: absolute;
  right: 31px;
  top: 0;
}

.cover-editor__display {
  background: url("/assets/imgs/font-dark.png") no-repeat;
  text-indent: -100vw;
  width: 320px;
}
</style>